import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { makeStyles, CardContent, TextField, Button } from '@material-ui/core'; // Import TextField and Button
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ServiceTable from '../Table/table';
import FormDialog from '../../../../components/table/FormDialog';
import { CommonConfig } from '../../../../config/common-config';
import token from '../../../../config/token';
import ServiceLayout from '../../../invoices/common/serviceLayout';
import { setSelectedImc } from '../../store/actions/index';
import '../../servicestyles.css';
import OpenServicePopUp from '../../Popup';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    // Existing styles here...
    jumpToPageContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        justifyContent: 'center',
    },
    inputField: {
        width: '60px',
        marginRight: theme.spacing(1),
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const OpenServiceAll = (props) => {
    const tokens = token();
    const dispatch = useDispatch({});
    const myRef = useRef();
    const { display } = props;
    const classes = useStyles();
    const location = useLocation();
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDomain = userDetails.result && userDetails.result.config.data;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setOpenService] = useState([]);
    const [selectedImc, setselectedImc] = useState('');
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [particularRow, setParticularRow] = useState([]);
    const vertical = 'top';
    const horizontal = 'center';
    const [page, setPage] = useState(0);
    const [pageInput, setPageInput] = useState(''); // New state for input field
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [rerender, setRerender] = useState(false);
    const usertypeValue = userDetails.result && userDetails.result.data.features[5].branchName;
    const userRoleText = userDetails.result && userDetails.result.data.features[0].roleText;
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);
    const [deleteService, setDeleteService] = useState(false);

    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientName', label: 'Client name' },
        { id: 'clientType', label: 'Client type' },
        { id: 'description', label: 'Description' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'statusId', label: 'Current status' },
    ];

    const history = useHistory();

    const scrollTop = () => {
        myRef.current.scrollIntoView();
    };

    const getCandidates = (currentPage = page) => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/services/${selectedImc}?page=${currentPage}&size=10&sort=${
                    usertypeValue === 'EM' || userRoleText === 'ITeCTeam-Others' ? 'date_Modified' : 'dateModified'
                },desc`,
                tokens
            )
            .then((response) => {
                scrollTop();
                setOpenService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        const domainName = userTeam === 'ITeC Team' ? location.state.domainname : dbname;
        setselectedImc(domainName);
        dispatch(setSelectedImc(selectedImc));

        if (selectedImc) {
            if (searchQuery && searchQuery.length > 2) {
                getSearchValue(searchQuery);
                setNoRecordCount(false);
            } else {
                setSearchData([]);
                getCandidates();
                setNoRecordCount(true);
            }
        }
        if (userTeam != 'ITeC Team') {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                setselectedImc(JsonUserDomain.tennantName);
                dispatch(setSelectedImc(JsonUserDomain.tennantName));
            }
        }
    }, [deleteService, page, selectedImc, tokens, rerender, setselectedImc]);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const setImc = (e) => {
        getCandidates();
        setPage(0);
        let imc = '';
        if (e.target) {
            imc = e.target.value;
        } else {
            imc = e;
        }
        setselectedImc(imc);
        dispatch(setSelectedImc(imc));
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);

        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
            setNoRecordCount(false);
            return true;
        } else {
            setSearchData([]);
            getCandidates(imc);
            setNoRecordCount(true);
            return false;
        }
    };

    const handleBackBtn = () => {
        history.push('/menu/openservice');
    };

    const handleClose = () => {
        setOpenBox(false);
    };

    const handleDelete = (row, data) => {
        if (usertype !== 'SUPERADMIN') {
            deleteIMCType(row, data, dbname);
        } else {
            deleteIMCType(row, data, selectedImc);
        }
    };

    const deleteIMCType = (row, data, value) => {
        if (row.serviceId) {
            axios
                .delete(`${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${value}/${row.serviceId}`, {
                    data: data,
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    setDeleteService(response.data);
                    if (response.data === 'SUCCESS') {
                        setDeleteMsg('Service deleted successfully');
                        history.push('/menu/closedservice');
                    }
                    setOpenBox(true);
                })
                .catch(() => {});
        }
    };

    const handleClickRow = (particularRow1) => {
        setParticularRow(particularRow1);
    };

    const handleSearchQuery = (data) => {
        setSearchQuery(data);
        if (data && data.length > 2) {
            setPage(0);
            setNoRecordCount(false);
            getSearchValue(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getCandidates(selectedImc);
        }
    };

    const handleRerender = () => {
        setRerender(!rerender);
    };

    const getSearchValue = (data) => {
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/services/${selectedImc}?search=${data}&page=${page}&size=10&sort=${
                    usertypeValue === 'EM' || userRoleText === 'ITeCTeam-Others' ? 'date_modified' : 'dateModified'
                },desc`,
                axiosConfig
            )
            .then((res) => {
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setOpenService([]);
                    }
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {});
    };

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getCandidates();
    };

    const handlePageInputChange = (e) => {
        setPageInput(e.target.value);
    };

    const handlePageJump = () => {
        const pageNumber = parseInt(pageInput, 10);
        if (!isNaN(pageNumber) && pageNumber >= 0) {
            setPage(pageNumber - 1); // Subtract 1 because pages are zero-indexed in the API
            getCandidates(pageNumber - 1);
        }
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <>
            <Snackbar open={openBox} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar>
            <div className={classes.root} ref={myRef}>
                <FormDialog row={[]} pageName="servicesedit" show="AddIcon" />
                <ServiceLayout
                    title="Open Services"
                    searchQuery={searchQuery}
                    onChange={handleSearchQuery}
                    clearField={clearField}
                    className={classes}
                >
                    {rows && filteredRow.length > 0 ? (
                        <>
                            <ServiceTable
                                headcells={headcells}
                                rows={filteredRow}
                                handleDelete={handleDelete}
                                handleClickRow={handleClickRow}
                                action
                                pageName="servicesedit"
                                post="admin"
                                service="open"
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                handleRerender={handleRerender}
                                selectedImc={selectedImc}
                            />
                        </>
                    ) : (
                        <div className={classes.noRecord}>
                            <h1>No records to display</h1>
                        </div>
                    )}
                </ServiceLayout>
                <div className={classes.jumpToPageContainer}>
                    <TextField
                        className={classes.inputField}
                        type="number"
                        value={pageInput}
                        onChange={handlePageInputChange}
                        label="Page Number"
                        variant="outlined"
                    />
                    <Button variant="contained" color="primary" onClick={handlePageJump}>
                        Go
                    </Button>
                </div>
                {userTeam === 'ITeC Team' ? (
                    <button className={classes.buttonBack} onClick={handleBackBtn}>
                        Back
                    </button>
                ) : null}
            </div>
        </>
    );
};

export default OpenServiceAll;
